import * as React from 'react';

export interface AppProps {
  children: any;
}

export const App = (props: AppProps) => {
  return (
    <div className="w-100 sans-serif bg-white black">
      <div className="mw9 ml-auto mr-auto">{props.children}</div>
    </div>
  );
};

export default App;
